module.exports = __webpack_public_path__ + "img/select-arrow-purple.c44ea059.svg";